import WicketsPerInningSetting from "./WicketsPerInningSetting";
export default WicketsPerInningSetting;
